export const ASSET_BASE_PATH = import.meta.env.VITE_APP_ASSET_BASE_PATH;
export const VMS_APP_PATH = import.meta.env.VITE_VMS_APP_PATH;
export const VAULT_API_BASE_URL = import.meta.env.VITE_VAULT_API_BASE_URL;
export const ADMIN_APP_PATH = import.meta.env.VITE_ADMIN_APP_PATH;
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const SENTRY_DSN = import.meta.env.VITE_APP_SENTRY_DSN;
export const ENVIRONMENT = import.meta.env.VITE_APP_ENVIRONMENT;
